import { configureStore } from "@reduxjs/toolkit";
import interfaceApp from "./slices/interfaceSlice";

export const store = configureStore({
  reducer: {
    interfaceApp,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
